/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Proxy_Status_CompleteInputs */

const en_iconik_proxy_status_complete = /** @type {(inputs: Iconik_Proxy_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy import completed.`)
};

const fr_iconik_proxy_status_complete = /** @type {(inputs: Iconik_Proxy_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation du proxy terminee.`)
};

const de_iconik_proxy_status_complete = /** @type {(inputs: Iconik_Proxy_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy-Import abgeschlossen.`)
};

const it_iconik_proxy_status_complete = /** @type {(inputs: Iconik_Proxy_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione proxy completata.`)
};

const ru_iconik_proxy_status_complete = /** @type {(inputs: Iconik_Proxy_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт через прокси завершен.`)
};

const es_iconik_proxy_status_complete = /** @type {(inputs: Iconik_Proxy_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación de proxy completada.`)
};

const zh_cn2_iconik_proxy_status_complete = /** @type {(inputs: Iconik_Proxy_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代理导入完成。`)
};

const ja_iconik_proxy_status_complete = /** @type {(inputs: Iconik_Proxy_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロキシのインポートが完了しました。`)
};

const hi_iconik_proxy_status_complete = /** @type {(inputs: Iconik_Proxy_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रॉक्सी आयात पूर्ण हो गया।`)
};

const pt_pt2_iconik_proxy_status_complete = /** @type {(inputs: Iconik_Proxy_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação do proxy concluída.`)
};

/**
* | output |
* | --- |
* | "Proxy import completed." |
*
* @param {Iconik_Proxy_Status_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_proxy_status_complete = /** @type {((inputs?: Iconik_Proxy_Status_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Proxy_Status_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_proxy_status_complete(inputs)
	if (locale === "de") return de_iconik_proxy_status_complete(inputs)
	if (locale === "it") return it_iconik_proxy_status_complete(inputs)
	if (locale === "ru") return ru_iconik_proxy_status_complete(inputs)
	if (locale === "es") return es_iconik_proxy_status_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_proxy_status_complete(inputs)
	if (locale === "ja") return ja_iconik_proxy_status_complete(inputs)
	if (locale === "hi") return hi_iconik_proxy_status_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_proxy_status_complete(inputs)
	return en_iconik_proxy_status_complete(inputs)
});